import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';
import { BoundWhiteLabelSelectors } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule';

import router from './router';

const defaultSupportLink = 'https://mcs.mail.ru/help/contact-us';

// a dictionary of reusable links of various types - urls, route ids, etc., to be the only source of truth
const LinkCatalog = {
    getCurrentAppSupportUrl() {
        const whiteLabelSettings = BoundWhiteLabelSelectors.getWhiteLabelSettings();
        const whiteQuestionForm =
            whiteLabelSettings?.support_contacts?.question_form_url;

        if (whiteQuestionForm) {
            return whiteQuestionForm;
        }

        return router.isPartnerApp()
            ? 'mailto:partner@mcs.mail.ru?Subject=Вопрос в техподдержку партнерской программы MCS'
            : LinkCatalog.getMainAppSupportUrl();
    },

    getHelpLink(page: string) {
        const whiteLabelSettings = BoundWhiteLabelSelectors.getWhiteLabelSettings();

        if (whiteLabelSettings?.support_contacts?.help_link) {
            return whiteLabelSettings.support_contacts.help_link;
        }

        const base = 'https://mcs.mail.ru/help/';
        return base + page;
    },

    getMainAppSupportUrl() {
        const whiteLabelSettings = BoundWhiteLabelSelectors.getWhiteLabelSettings();

        return (
            whiteLabelSettings?.support_contacts?.support_link ||
            defaultSupportLink
        );
    },

    getInfraSupportEmail() {
        const whiteLabelSettings = BoundWhiteLabelSelectors.getWhiteLabelSettings();
        const supportEmail = whiteLabelSettings?.support_contacts?.email;
        const userEmail = BoundCurrentUserSelectors.getEmail();
        const mailSubject = `?subject=${userEmail}${encodeURI(
            ' обращение в службу поддержки',
        )}`;

        return supportEmail
            ? `mailto:${supportEmail}${mailSubject}`
            : defaultSupportLink;
    },

    getInfraOffersUrl() {
        return '/cloud-servers/#pricing';
    },
};

export { LinkCatalog };
